import { memo, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { palette } from "../../theme/palette";

import { getRouteRoadSpeedExtract } from "../../utils/routeExtract";

import {
  routesSelector,
  routeConfigSelector,
} from "../../reducers/routeManagement/selectors";

import { View } from "../Base";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "30px",
    padding: "0rem 0.5rem",
  },
  button: {
    backgroundColor: palette.sunburst,
    fontSize: "11px",
    height: "17px",
    width: "95px",
    "&:hover": {
      backgroundColor: palette.sunburst,
      opacity: 0.6,
    },
  },
  text: {
    color: palette.white,
    fontSize: "14px",
    fontWeight: "500",
  },
  anchor: {
    display: "none",
  },
});

export const RouteExtractBar = memo(() => {
  const styles = useStyles();
  const downloadRef = useRef();
  const routes = useSelector(routesSelector);
  const routeConfig = useSelector(routeConfigSelector);
  const [{ url, fileName }, setDownload] = useState({});

  useEffect(() => {
    if (!url || !downloadRef?.current) return;
    downloadRef.current.click();
    URL.revokeObjectURL(url);
    setDownload({});
  }, [url]);

  const onExtractClick = () => {
    if (url) return;
    else setDownload(getRouteRoadSpeedExtract(routes, routeConfig));
  };

  return routes.length ? (
    <View className={styles.container}>
      <Typography className={styles.text}>
        {`Depot Routes: ${routes.length}`}
      </Typography>
      <Button className={styles.button} onClick={onExtractClick}>
        Extract CSV
      </Button>
      <a
        className={styles.anchor}
        ref={downloadRef}
        download={fileName}
        href={url}
      >
        Download Route Extract
      </a>
    </View>
  ) : null;
});
